import React from "react";

interface IFolderEmptyIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const FolderEmptyIcon: React.FC<IFolderEmptyIconProps> = ({
  size = 20,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.7}
      strokeDasharray="3 2.5"
      d="M3 6a2 2 0 0 1 2-2h4l2 2.5h8a2 2 0 0 1 2 2V18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6z"
    />
  </svg>
);
